class ProductMedia extends window.BAO.CustomElement() {
  constructor() {
    super()
    this.handleResize = this.handleResize.bind(this)
    this.scrollPosition = 0
  }

  connectedCallback() {
    super.connectedCallback()

    this.initFeatures()
    window.addEventListener('resize', this.handleResize)

    this.els?.slide?.elements.forEach(img => {
      img.addEventListener('click', (event) => {
        if (this.classList.contains('prd-Detail_Media-fullscreen')) {
          this.exitFullscreen()
        } else {
          this.enterFullscreen(event.currentTarget.dataset.index)
        }
      })
    })

    this.els?.slide?.elements.forEach(slideEl => {
      const mediaImageEl = slideEl.querySelector('img')

      if (mediaImageEl) {
        this.pinchZoom(mediaImageEl)
      }
    })
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize)
    super.disconnectedCallback()
  }

  initFeatures() {
    if (window.innerWidth <= 901) {
      if (!this.carousel) {
        this.setupCarousel()
      }
    } else {
      if (this.carousel) {
        this.carousel.destroy()
        this.carousel = null
        this.els.slides.element.classList.remove('keen-slider')
        this.els.slide.elements.forEach(el => el.classList.remove('keen-slider__slide'))
      }
      this.setupIntersectionObserver()
    }
  }

  handleResize() {
    this.initFeatures()
  }

  setupCarousel() {
    this.els.slides.element.classList.add('keen-slider')
    this.els.slide.elements.forEach(el => el.classList.add('keen-slider__slide'))

    this.carousel = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        rubberband: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 1,
        },
      },
      [
        window.BAO.Carousel.plugins.useInitialised(),
        window.BAO.Carousel.plugins.useDots(this.els?.dot?.elements)
      ],
    )
  }

  setupIntersectionObserver() {
    const options = {
      threshold: 0.5,
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.updateActiveDot(entry.target.id)
        }
      })
    }, options)

    this.els?.slide?.elements.forEach(img => {
      observer.observe(img)
    })
  }

  updateActiveDot(activeId) {
    this.els?.dot?.elements.forEach(dot => {
      if (dot.getAttribute('href') === `#${activeId}`) {
        dot.setAttribute('aria-current', 'true')
      } else {
        dot.removeAttribute('aria-current')
      }
    })
  }

  enterFullscreen(index) {
    this.scrollPosition = window.scrollY
    this.classList.add('prd-Detail_Media-fullscreen')
    document.body.classList.add('util-SiteOverflowed')
    this.scrollToImage(index)
  }

  exitFullscreen() {
    this.classList.remove('prd-Detail_Media-fullscreen')
    document.body.classList.remove('util-SiteOverflowed')
    window.scrollTo(0, this.scrollPosition)
  }

  scrollToImage(index) {
    const targetSlide = this.els.slide.elements.find(slide => slide.dataset.index === index)
    if (targetSlide) {
      targetSlide.scrollIntoView()
    }
  }

  pinchZoom(imageElement) {
    this.imageElementScale = 1
    this.isScaled = false

    this.singleTouchX = 0
    this.singleTouchY = 0

    const start = {}

    // Calculate distance between two fingers
    const distance = event => {
      return Math.hypot(
        event.touches[0].pageX - event.touches[1].pageX,
        event.touches[0].pageY - event.touches[1].pageY,
      )
    }

    document.body.addEventListener(
      'touchstart',
      event => {
        if (event.target === imageElement) {

          if (event.touches.length === 2) {
            event.preventDefault() // Prevent page scroll

            // Calculate where the fingers have started on the X and Y axis
            start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2
            start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2
            start.distance = distance(event)

            document.body.classList.add('lyt-Site-pinchZoomActive')

            const initialTransformValue = document.querySelector('.prd-Media_Item-active',).style.transform
            document.documentElement.style.setProperty(
              '--initial-transform',
              initialTransformValue,
            )
          }
        }
      },
      { passive: false }, // Changed to false to allow preventDefault
    )

    imageElement.addEventListener(
      'touchmove',
      event => {
        if (event.touches.length === 2) {
          event.preventDefault() // Prevent page scroll
          event.stopPropagation() // Stop event bubbling to carousel

          this.isScaled = true

          // Safari provides event.scale as two fingers move on the screen
          // For other browsers just calculate the scale manually
          let scale
          if (event.scale) {
            scale = event.scale
          } else {
            const deltaDistance = distance(event)
            scale = deltaDistance / start.distance
          }
          this.imageElementScale = Math.min(Math.max(1, scale), 4)

          // Calculate how much the fingers have moved on the X and Y axis
          this.deltaX =
            ((event.touches[0].pageX + event.touches[1].pageX) / 2 - start.x) *
            2 // x2 for accelarated movement
          this.deltaY =
            ((event.touches[0].pageY + event.touches[1].pageY) / 2 - start.y) *
            2 // x2 for accelarated movement

          // Transform the image to make it grow and move with fingers
          const transform = `translateX(${this.deltaX}px) translateY(${this.deltaY}px) scale(${this.imageElementScale})`
          imageElement.style.transform = transform
          imageElement.style.WebkitTransform = transform
        }

        if (event.touches.length === 1 && this.isScaled === true) {
          event.preventDefault() // Prevent page scroll
          event.stopPropagation() // Stop event bubbling to carousel

          const movementX = event.touches[0].pageX - this.singleTouchX
          const movementY = event.touches[0].pageY - this.singleTouchY

          const newX = this.deltaX + movementX
          const newY = this.deltaY + movementY

          const transform = `translateX(${newX}px) translateY(${newY}px) scale(${this.imageElementScale})`
          imageElement.style.transform = transform
          imageElement.style.WebkitTransform = transform
        }
      },
      { passive: false }, // Changed to false to allow preventDefault
    )

    imageElement.addEventListener(
      'touchend',
      event => {
        if (event.touches.length === 1) {
          this.singleTouchX = event.touches[0].pageX
          this.singleTouchY = event.touches[0].pageY
        }

        if (event.touches.length === 0) {
          // Reset image to it's original format
          imageElement.style.transform = ''
          imageElement.style.WebkitTransform = ''

          document.body.classList.remove(
            'lyt-Site-pinchZoomActive'
          )

          this.isScaled = false
        }
      },
      { passive: true },
    )
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
